export default __webpack_public_path__ + "static/media/desktop.70b98d29.jpg";